import { TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import {
  NumberField,
  RecordContextProvider,
  TextField,
  usePermissions,
} from "react-admin";
import useCompanyScopedListFilters from "../../../hooks/useCompanyScopedListFilters";

const AccountReceivablePcmOverviewFooterList = () => {
  const { currentCompanyFilter } = useCompanyScopedListFilters();
  const { permissions } = usePermissions();
  const canSeeCompanyColumn =
    permissions?.administrator ||
    permissions?.superadmin ||
    permissions?.update_company;
  const { data, isLoading, error } = useGrandTotal(
    "grand-total",
    currentCompanyFilter
  );

  // if (error) return <Error />;

  return (
    <RecordContextProvider value={data ? data : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell colSpan={canSeeCompanyColumn ? 3 : 2}>
            <RecordContextProvider value={{ name: "GRAND TOTAL" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_previous_ar" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_previous_pcm" textAlign="right" />
          </TableCell>
          <TableCell></TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_total_ar" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_total_pcm" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_total_ar_pcm" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_final_ar" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="grand_total_final_pcm" textAlign="right" />
          </TableCell>
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default AccountReceivablePcmOverviewFooterList;
